import {
  SET_DOCUMENT_FILE,
  SET_DOCUMENT_SELECTED,
  SET_EFIMERO_FOLDERS,
  SET_ENABLE_DOCS,
  SET_IMAGEVALUE,
  SET_LOADING_IMAGE,
  SET_NUMBER_PAGE,
  SET_REQUESTED_LIST,
  SET_SIGNED_DOCS,
  SET_SIGNED_LAST_DOC_ID,
  SET_TOTAL_PAGES,
  SET_UNSIGNED_DOCS,
  SET_UNSIGNED_LAST_DOC_ID,
  SET_UNSIGNED_TOTAL_DOCS,
  UPDATE_DOCUMENT_SELECTED,
  UPDATE_EFORM_SIGNED,
  SET_DOCUMENTS_UNSIGNED_PARAMS_FILTER,
  SET_DOCUMENTS_SIGNED_PARAMS_FILTER,
  SET_FOLDERS_AVAILABLES,
  CLEAR_ALL_DOCUMENTS_STATE,
} from './mutations-types'

const mutations = {
  [SET_UNSIGNED_TOTAL_DOCS]: (state, payload) => {
    state.documentsTotalUnsigned = payload
  },
  [SET_SIGNED_DOCS]: (state, payload) => {
    state.signed = payload
  },
  [SET_UNSIGNED_DOCS]: (state, payload) => {
    state.unsigned = payload
  },
  [SET_ENABLE_DOCS]: (state, payload) => {
    state.documents = payload
  },
  [SET_EFIMERO_FOLDERS]: (state, payload) => {
    state.efimeroFoldersIds = payload
  },
  [SET_DOCUMENT_SELECTED]: (state, payload) => {
    state.document = { ...payload }
  },
  [SET_IMAGEVALUE]: (state, payload) => {
    state.imageValue = payload
  },
  [UPDATE_DOCUMENT_SELECTED]: (state, payload) => {
    const { document } = state
    document.firmado = payload
    state.document = { ...document }
  },
  [UPDATE_EFORM_SIGNED]: state => {
    const { document } = state
    const newArchive = `${document.archivo}.signed.pdf`
    document.firmado = 'FIRMADO CONFORME'
    document.archivo = newArchive
    state.document = { ...document }
  },
  [SET_LOADING_IMAGE]: (state, payload) => {
    state.loading = payload
  },
  [SET_DOCUMENT_FILE]: (state, payload) => {
    state.file = payload
  },
  [SET_NUMBER_PAGE]: (state, payload) => {
    state.page = payload
  },
  [SET_TOTAL_PAGES]: (state, payload) => {
    state.totalPages = payload
  },
  [SET_REQUESTED_LIST]: (state, payload) => {
    state.requestedList = payload
  },
  [SET_UNSIGNED_LAST_DOC_ID]: (state, payload) => {
    state.unSignedLastId = payload
  },
  [SET_SIGNED_LAST_DOC_ID]: (state, payload) => {
    state.signedLastId = payload
  },
  [SET_DOCUMENTS_UNSIGNED_PARAMS_FILTER]: (state, payload) => {
    state.unsignedFilters = payload
  },
  [SET_DOCUMENTS_SIGNED_PARAMS_FILTER]: (state, payload) => {
    state.signedFilters = payload
  },
  [SET_FOLDERS_AVAILABLES]: (state, payload) => {
    state.folders = payload
  },
  [CLEAR_ALL_DOCUMENTS_STATE]: (state) => {
    // Resetear todo el estado a los valores iniciales
    state.efimeroFoldersIds = []
    state.folders = []
    state.signed = []
    state.unsigned = []
    state.signedLastId = false
    state.unSignedLastId = false
    state.signedFilters = {}
    state.unsignedFilters = {}
    state.documents = []
    state.documentsTotalUnsigned = 0
    state.document = {}
    state.imageValue = ''
    state.loading = false
    state.file = ''
    state.page = 1
    state.totalPages = 0
    state.requestedList = false
  },
}

export default mutations
